module.exports = __webpack_public_path__ + "static/img/aws-cci-4.6c5bdfe4.png";